// lib
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Route } from "react-router-dom";

// src
import { loginAndKeepPath } from "actions/user/thunks";

const AuthRejected = () => {
  const { t } = useTranslation();

  return (
    <p className="auth-rejected" role="alert">
      {t("errors.unknownAccount")}
    </p>
  );
};

const LoggedRoute = ({ component: Component, ...rest }) => {
  const { isLogged, isAuthAborted, isAuthPending, isAuthRejected } = useSelector(
    (state) => state.user,
  );
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    if (isLogged || isAuthAborted || isAuthPending || isAuthRejected) return;
    dispatch(loginAndKeepPath(pathname));
  }, [dispatch, isAuthAborted, isAuthPending, isAuthRejected, isLogged, pathname]);

  const render = () => {
    if (isLogged) return <Component />;
    if (isAuthRejected) return <AuthRejected />;
    return null;
  };

  return <Route render={render} {...rest} />;
};

LoggedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default LoggedRoute;
